export default __webpack_public_path__ + "static/media/file_00001 (8).8e6c8243.pdf";